"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanCodeInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var mall_1 = require("../../model/mall");
var service_1 = require("../../../library/base/service");
var ScanCodeInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ScanCodeInit, _super);
    function ScanCodeInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '积分充值扫码初始化';
        _this.code = '101174';
        _this.desc = '积分充值扫码初始化';
        _this.requestParams = new mall_1.ScanCodeInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ScanCodeInit;
}(service_1.BaseService));
exports.ScanCodeInit = ScanCodeInit;
//# sourceMappingURL=scanCodeInit.js.map